import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalService } from 'src/app/shared/services/modal/modal.service';
import { UniteCulturaleService } from '../../../../../../../data/declaration/services/parcellaire/unite-culturale.service';
import { TranslateService } from '@ngx-translate/core';
import { RefCultureBio } from '../../../../../../../data/declaration/models/ref-culture-bio.model';
import { UniteCulturale } from '../../../../../../../data/declaration/models/unite-culturale.model';

@Component({
    selector: 'app-culture-bio',
    templateUrl: './culture-bio.component.html',
    styleUrls: ['./culture-bio.component.scss'],
    standalone: false
})
export class CultureBioComponent implements OnInit {
    formGroup: UntypedFormGroup;
    @Input() refCultureBios: RefCultureBio[];
    @Input() uniteCulturalesSelectionnees: UniteCulturale[];

    constructor(
        public readonly modal: NgbActiveModal,
        private readonly fb: UntypedFormBuilder,
        private readonly modalsService: ModalService,
        private readonly uniteCulturaleService: UniteCulturaleService,
        private readonly translate: TranslateService
    ) {}
    get cultureBio() {
        return this.formGroup.get('cultureBio');
    }

    ngOnInit() {
        this.formGroup = this.fb.group({
            cultureBio: [undefined, Validators.required]
        });
    }

    cancel() {
        this.modal.dismiss();
    }

    submit() {
        if (this.formGroup.valid) {
            this.uniteCulturaleService.cultureBioMasseUniteCulturale(this.uniteCulturalesSelectionnees, this.cultureBio.value).subscribe(() => {
                this.modal.close();
            });
        } else {
            this.modalsService
                .error(this.translate.instant('page.inventaire-verger.modals.cultureBio.cultureBioError'), null, { windowClass: 'anpp' })
                .then(() => {});
        }
    }
}
